export const patientReferralConstants = {
  REFERRALS_LIST_PROCESSING: "REFERRALS_LIST_PROCESSING",
  REFERRALS_LIST_SUCCESS: "REFERRALS_LIST_SUCCESS",
  REFERRALS_LIST_FAILURE: "REFERRALS_LIST_FAILURE",
  TOTAL_RECORDS_SUCCESS: "TOTAL_RECORDS_SUCCESS"
};
